'use client'

import React from 'react'
import { toast } from 'sonner'
import { useModals, usePrinter } from '@/lib/hooks'

import { Button, Receipt, ScrollArea } from '@/components/ui'

export const PrintReceipt = ({
  printerType,
  receipt,
}: {
  printerType: string | null
  receipt: any
}) => {
  const { closeModal } = useModals()
  const { requestPrinter, printer, printReceipt } = usePrinter()
  const hasOpenedReceipt = React.useRef(false)

  const printNow = React.useCallback(async () => {
    await printReceipt(receipt)
  }, [printReceipt, receipt])

  React.useEffect(() => {
    if (receipt && printerType !== null && !hasOpenedReceipt.current) {
      hasOpenedReceipt.current = true
      if (printerType !== 'thermal') {
        if (!receipt?.url) {
          toast.error('Could not find receipt URL')
          return
        }

        window.open(receipt?.url, '_blank')
      } else {
        printNow()
      }
    }
  }, [receipt, printerType, printNow])

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-col gap-8">
        <ScrollArea className="max-h-[500px] print:h-auto">
          <Receipt data={receipt} />
        </ScrollArea>

        <div className="flex w-full items-center gap-2 print:hidden">
          <Button
            size="lg"
            variant="secondary"
            className="w-full"
            onClick={() => {
              closeModal('PRINT_RECEIPT')
            }}
          >
            Close
          </Button>

          {printerType !== 'thermal' && (
            <Button
              size="lg"
              className="w-full"
              onClick={() => {
                if (!receipt?.url) {
                  toast.error('Could not find receipt URL')
                  return
                }

                window.open(receipt?.url, '_blank')
              }}
            >
              Print Receipt
            </Button>
          )}

          {!printer && printerType === 'thermal' && (
            <Button size="lg" className="w-full" onClick={requestPrinter}>
              Connect Printer
            </Button>
          )}

          {printer && printerType === 'thermal' && (
            <Button
              size="lg"
              className="w-full"
              onClick={printNow}
              disabled={!printer}
            >
              Print Receipt
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
